import * as React from 'react';
import './ArticleVariety.css';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPost, getPostIdle } from '../../store/ducks/post/actions';
import { postSelector } from '../../store/ducks/post/selectors/postSelector';
import { Instructions } from '../../components/Instructions/Instructions';
import { StateStatus } from '../../types/models';
import { Helmet } from 'react-helmet';
import { InfiniteLine } from '../../components/InfiniteLine/InfiniteLine';
import { Loading } from '../../components/UI/Loading/Loading';
import { PostSelectorType } from '../../store/ducks/post/types';
import Quiz from '../Quiz/Quiz';

import { Share } from '../../components/Share/Share';
import { domainName } from '../../config';

import { getQuiz } from '../../store/ducks/quiz/actions';
import { quizSelector } from '../../store/ducks/quiz/selectors/quizSelector';
import NotFoundPage from '../404/404';
import { Mailing } from '../../components/Mailing/Mailing'

export default function ArticleVariety() {
    const dispatch = useDispatch();
    const { slug, category }: { slug: string; category: string } = useParams();

    const location = useLocation();
    const path = location.pathname;

    let status = useSelector(
        (state: { post: { status: StateStatus } }) => state.post.status
    );

    const { post }: { post: PostSelectorType } = useSelector(postSelector);

    const history = useHistory();
    const baseUrl = 'https://' + domainName + history.location.pathname;
    const url = new URL(baseUrl + history.location.search);
    const param = url.searchParams.get('r');

    const { quiz } = useSelector(quizSelector);
    console.log('quiz: ', quiz);

    useEffect(() => {
        if (status === 'SUCCESS') {
            dispatch(getPostIdle());
        }
    }, [status]);

    useEffect(() => {
        const header = document.querySelector('.header');
        header.classList.remove('_active');

        if (status === 'IDLE' && path.indexOf('posts/tests/') < 0) {
            dispatch(getPost(slug));
        } else if (status === 'IDLE' && path.indexOf('posts/tests/') > 0) {
            dispatch(getPost(slug));
            dispatch(getQuiz(slug));
        }
    }, [slug]);

    if (!post || status === 'LOADING') return <Loading />;
    if (post && post.categoriesEn.indexOf(category) < 0  && post.categoriesEn !== "tests") return <NotFoundPage/>;

    

    return (
        <>
            <Helmet>
                <title>{post.og.title}</title>
                <link rel="canonical" href={baseUrl} />
                <meta property="og:title" content={post.og.title} />
                <meta property="twitter:title" content={post.og.title} />
                <meta name="description" content={post.og.description} />
                <meta property="og:description" content={post.og.description} />
                <meta
                    property="twitter:description"
                    content={post.og.description}
                />
                {/* <meta property="og:image" content={post.og.image} /> */}
                {/* <meta property="og:url" content={post.og.url} /> */}
                <meta
                    property="og:image"
                    content={
                        (param && quiz && quiz.imgShareList[param]) ||
                        post.og.image
                    }
                />

                <meta
                    property="og:url"
                    content={baseUrl + (param ? '?r=' + param : '')}
                />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>
            {post && post.categoriesEn !== "tests" && (
                <main className={`page ${post && "_article-variety"}`}>
                    <section className="article">
                        <div className="article__header">
                            <div className="__container">
                                <div className="article__header-wrap">
                                    <div className="article__header-col">
                                        <div className="article__info">
                                            <span className="article__tag">
                                                {post.categories}
                                            </span>
                                            <div className="article__data">
                                                {post.date}
                                            </div>
                                        </div>
                                        <div
                                            className="article__title"
                                            dangerouslySetInnerHTML={{
                                                __html: post.title,
                                            }}
                                        ></div>
                                        {(post.textAuthor ||
                                            post.photoAuthor) && (
                                            <div className="article-authors article__authors">
                                                {post.textAuthor && (
                                                    <div className="article-authors__item">
                                                        <div className="article-authors__title">
                                                            Автор
                                                        </div>
                                                        <div className="article-authors__text">
                                                            {post.textAuthor}
                                                        </div>
                                                    </div>
                                                )}
                                                {post.photoAuthor && (
                                                    <div className="article-authors__item">
                                                        <div className="article-authors__title">
                                                            Фотографии
                                                        </div>
                                                        <div className="article-authors__text">
                                                            {post.photoAuthor}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    <div className="article__header-col">
                                        {post.image && post.image !== '' && (
                                            <div className="article__header-ibg">
                                                <img
                                                    src={post.image}
                                                    alt={post.title}
                                                />
                                                <div className="article__header-author">
                                                    {post.cover.author}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="article__body">
                            <div className="article__container">
                                <div className="article__body-content">
                                    <div
                                        className="article__text--main"
                                        dangerouslySetInnerHTML={{
                                            __html: post.lead,
                                        }}
                                    ></div>
                                </div>
                                <div className="article__body-content-wrap">
                                    <div className="article__body-content-wrap-col">
                                        <div className="scroll-block">
                                            <Mailing email="" check=""/>
                                        </div>
                                    </div>
                                    <div className="article__body-content-wrap-col">
                                        <div
                                            className="article__body-content article__body-content--full"
                                            dangerouslySetInnerHTML={{
                                                __html: post.content,
                                            }}
                                        >
                                            
                                        </div>
                                        <div className="article__body-content">
                                            <Share debug mod="" url="" />
                                            <Mailing email="" check=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <InfiniteLine mod="_2" /> */}

                    <Instructions />
                </main>
            )}

            {path.indexOf('posts/tests/') > 0 && <Quiz quiz={quiz} />}
        </>
    );
}
